import { render, staticRenderFns } from "./EpiSuiteDetailed.vue?vue&type=template&id=e42580e0"
import script from "./EpiSuiteDetailed.vue?vue&type=script&setup=true&lang=js"
export * from "./EpiSuiteDetailed.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports